import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: 'mmdd'
})
export class MmddPipe implements PipeTransform {

  transform(value: Date): string {
    if (!value) return "00/00";
    let date = new Date(value);
    var dateShamsi = jalalimoment(date.toString()).locale('fa').format('YYYY/MM/DD')
    return `${dateShamsi.substring(5)}`;
  }

}
